import { autoinject } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { guid } from 'app/shared/lib/guid';


@autoinject()
export class DemoEssTooltipPage extends ComponentBase {
    protected id: guid = guid();

    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(...rest: any[]) {
        super(...rest);
    }

    protected positionOptions: string[] = ['top', 'bottom', 'left', 'right']
    protected selectedPosition?: string = 'bottom'
}
